<template>
    <!--
     Vue 计算属性演示- 核心根据仓库变量包装返回处理结果,比如数据验证
    -->
    <div>
       <p>
         <label for="name">姓名</label>
         <input type="text" v-model="name"/>
       </p>
       <p>
         <label for="age">年龄</label>
         <input type="text" v-model="age"/>
       </p>
       <p>
         <label for="sex">性别</label>
         <input type="text" v-model="sex"/>
       </p>

       <input type="submit" value="提交数据"  :disabled="selecchk" />
       <p>{{selectedCount}}</p>
       <hr/>
    </div>
</template>
<script>
import { Indicator, Toast } from 'mint-ui'
export default {
   name:'ttindex',
   data(){
     return{
        name:'',
        age:'',
        sex:'',
     }
   },
   computed:{
      selectedCount(){
        console.log("selectedCount--todo");
        return "6666";
      },
      selecchk(){//计算属性如果是方法类型,有只读性不能修改
         if(this.name.length>0&&this.age.length>0&&this.sex.length>0){
            return false;
         }
         return true;
      },
      getmsg:{//计算属性取值为对象时候, 必须遵循Vue定义
        get(){//当前计算属性取值

        },
        set(v){//当前计算属性赋值,Vue默认给形参
          
        }
      }
   },
   methods:{
      
   } 
}
</script>
